import React from 'react';

import './Task.css'; // Import the CSS file for Task component

import ManageTemplate from '../EmailTemp/ManageTemplate';

const Task = () => {
  return (

      
      

      <ManageTemplate/>

      
 
  );
};

export default Task;
